<template>
    <v-form v-model="$storeDemandeBourse.ValidBaccalaureat" ref="refBaccalaureat" lazy-validation>
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="6">
                        <v-autocomplete 
                        label="Année obtention du BAC" 
                        v-model="$storeDemandeBourse.DonneesFormulaire.AnneeObtentionBac"
                        item-text="lang00"
                        item-value="id"
                        :items="$storeCatalogue.AnneeScolaire"
                        :clearable="!$storeDemandeBourse.ReadOnly"
                        :rules="$storeReglesBourse.obligatoire"
                        ref="anneebac"
                        :readonly="$storeDemandeBourse.ReadOnly"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-autocomplete 
                        label="Type de BAC" 
                        v-model="$storeDemandeBourse.DonneesFormulaire.TypeBac"
                        item-text="lang00"
                        item-value="id"
                        :items="$storeCatalogue.TypeBac"
                        :rules="$storeReglesBourse.obligatoire"
                        ref="typebac"
                        :clearable="!$storeDemandeBourse.ReadOnly"
                        :readonly="$storeDemandeBourse.ReadOnly"
                        @change="typeBacChange"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field 
                        label="Autre type de BAC"
                        v-model="$storeDemandeBourse.DonneesFormulaire.AutreTypeBac"
                        v-show="$storeDemandeBourse.DonneesFormulaire.TypeBac == $storeCatalogue.DataId.AutreBac"
                        :rules="$storeDemandeBourse.DonneesFormulaire.TypeBac == $storeCatalogue.DataId.AutreBac ? $storeReglesBourse.obligatoire : []"
                        ref="autretypebac"
                        :readonly="$storeDemandeBourse.ReadOnly"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="6">
                        <v-autocomplete 
                        label="Filière de BAC" 
                        v-model="$storeDemandeBourse.DonneesFormulaire.FiliereBac"
                        item-text="lang00"
                        item-value="id"
                        :items="$storeCatalogue.FiliereBacAffiche"
                        :rules="$storeDemandeBourse.DonneesFormulaire.TypeBac != $storeCatalogue.DataId.AutreBac ? $storeReglesBourse.obligatoire : []"
                        ref="filierebac"
                        :clearable="!$storeDemandeBourse.ReadOnly"
                        :readonly="$storeDemandeBourse.ReadOnly"
                        v-show="$storeDemandeBourse.DonneesFormulaire.TypeBac != $storeCatalogue.DataId.AutreBac"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field 
                            label="Autre filière de BAC"
                            v-model="$storeDemandeBourse.DonneesFormulaire.AutreFiliereBac"
                            :readonly="$storeDemandeBourse.ReadOnly"
                            :rules="$storeDemandeBourse.DonneesFormulaire.TypeBac == $storeCatalogue.DataId.AutreBac
                                    || $storeDemandeBourse.DonneesFormulaire.FiliereBac == $storeCatalogue.DataId.AutreFiliere 
                                    ? $storeReglesBourse.obligatoire : []"
                            ref="autrefilierebac"
                            v-show="$storeDemandeBourse.DonneesFormulaire.TypeBac == $storeCatalogue.DataId.AutreBac || $storeDemandeBourse.DonneesFormulaire.FiliereBac == $storeCatalogue.DataId.AutreFiliere"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-autocomplete 
                        label="Lycée" 
                        v-model="$storeDemandeBourse.DonneesFormulaire.Lycee"
                        item-text="label"
                        item-value="idCrypte"
                        :items="$storeDemandeBourse.Lycee"
                        :clearable="!$storeDemandeBourse.ReadOnly"
                        :rules="!$storeDemandeBourse.DonneesFormulaire.NomLyceeAutre ? $storeReglesBourse.obligatoire : []"
                        ref="lycee"
                        :readonly="$storeDemandeBourse.ReadOnly"
                        v-show="$storeDemandeBourse.DonneesFormulaire.TypeBac == $storeCatalogue.DataId.TypeBacMarocain"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                        :label="$storeDemandeBourse.DonneesFormulaire.TypeBac == $storeCatalogue.DataId.TypeBacMarocain ? 'Ou saisir le nom du lycée : ' : 'Nom du lycée'"
                        v-model="$storeDemandeBourse.DonneesFormulaire.NomLyceeAutre"
                        ref="nomlyceeautre"
                        :rules="!$storeDemandeBourse.DonneesFormulaire.Lycee ? $storeReglesBourse.obligatoire : []"
                        :readonly="$storeDemandeBourse.ReadOnly"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-form>
</template>
<script>
export default {
    data() {
        return{
            $storeDemandeBourse: this.$storeDemandeBourse,
            $storeReglesBourse: this.$storeReglesBourse,
            $storeCatalogue: this.$storeCatalogue,
        }
    },
    created(){
        var self = this;
        Promise.all([
            this.$storeDemandeBourse.ListeLyceesMarocains()
            .then(response=>{
                if(response.data){
                    this.$storeDemandeBourse.LyceeMarocains = response.data;
                }
            }),
            this.$storeDemandeBourse.ListeLyceesFrancais()
            .then(response=>{
                if(response.data){
                    this.$storeDemandeBourse.LyceeFrancais = response.data;
                }
            }),
        ])
        .then(function () {
            self.loader = false;
            self.SourceCataloguesLycee()
        });
        
    },
    mounted(){
        this.$refs.refBaccalaureat.resetValidation();
    },
    methods:{
        ValiderForm(){
        this.$refs.refBaccalaureat.validate();
        let listeErreur =[];
        Object.keys(this.$refs).forEach(key => {
            if(key != "refBaccalaureat"){
                if((!this.$refs[key].valid && this.$refs[key].valid != undefined)
                || (this.$refs[key].valid == undefined
                    && this.$refs[key].$children != undefined
                    && this.$refs[key].$children[0] != undefined 
                    && !this.$refs[key].$children[0].valid)){
                    let label = this.$refs[key].label;
                    if(!label){
                    let inp = this.$refs[key];
                    if(!inp.$attrs){
                        inp = inp[0];
                    }
                    label = inp.$attrs["itemprop"];
                    }
                    listeErreur.push(label);
                }
            }
        });
        return listeErreur;
        },
        // méthodes on change
        typeBacChange(){
            // RAZ des valeurs renseignées si le type de bac change.
            if(this.$storeDemandeBourse.DonneesFormulaire.FiliereBac){
                this.$storeDemandeBourse.DonneesFormulaire.FiliereBac=null;
            }
            if(this.$storeDemandeBourse.DonneesFormulaire.AutreTypeBac){
                this.$storeDemandeBourse.DonneesFormulaire.AutreTypeBac = null
            }
            if(this.$storeDemandeBourse.DonneesFormulaire.AutreFiliereBac){this.$storeDemandeBourse.DonneesFormulaire.AutreFiliereBac = null;}
            if(this.$storeDemandeBourse.DonneesFormulaire.Lycee){this.$storeDemandeBourse.DonneesFormulaire.Lycee = null;}
            if(this.$storeDemandeBourse.DonneesFormulaire.NomLyceeAutre){this.$storeDemandeBourse.DonneesFormulaire.NomLyceeAutre = null;}

            this.SourceCataloguesLycee();
        },
        SourceCataloguesLycee(){
            if(this.$storeDemandeBourse.DonneesFormulaire.TypeBac){
                this.$storeCatalogue.FiliereBacAffiche = this.$storeCatalogue.GetByParentId(this.$storeCatalogue.FiliereBac, this.$storeDemandeBourse.DonneesFormulaire.TypeBac)
                if(this.$storeDemandeBourse.DonneesFormulaire.TypeBac == this.$storeCatalogue.DataId.TypeBacFrancais){
                    this.$storeDemandeBourse.Lycee = this.$storeDemandeBourse.LyceeFrancais;
                }
                else if(this.$storeDemandeBourse.DonneesFormulaire.TypeBac == this.$storeCatalogue.DataId.TypeBacMarocain){
                    this.$storeDemandeBourse.Lycee = this.$storeDemandeBourse.LyceeMarocains;
                }
            }
            else{
                this.$storeCatalogue.FiliereBacAffiche = this.$storeCatalogue.FiliereBac;
            }
        }
    }
}
</script>